import { Icon } from '@recargas-dominicanas/core/components';
import { useRef, type ChangeEvent, type MouseEvent } from 'react';
import { style } from './search-bar.module.css';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export function SearchBar(props: Props) {

  const { value, onChange } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  function handleClear(event?: MouseEvent<HTMLElement>) {
    event?.stopPropagation();
    onChange('');
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    onChange(event.target.value);
  }

  return (
    <div 
      className={style.container}
      onClick={() => inputRef.current?.focus()}>
      <Icon 
        className={style.searchIcon} 
        icon='search'/>
      <input 
        ref={inputRef}
        className={style.input}
        value={value} 
        placeholder='Buscar por id o nombre'
        onChange={handleChange}/>
      {value.trim() &&
        <Icon 
          className={style.clearIcon} 
          icon='clear'
          onClick={handleClear}/>
      }
    </div>
  );
}
